import { ResourceModalContent } from './ResourceModalContent';
export default ResourceModalContent;